import './checkbox.scss'
import { Box, Checkbox, Typography } from '@mui/material'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toCamelCase } from '../../../../utilities/formatters/camelCase'

const CheckboxItem = ({ propertie, ruleParameters, setRuleParameters, label, text, isEditing, filterTemplate, schema }) => {
  const {t} = useTranslation(['common', 'rules'])
  const [value, setValue] = useState(false)

  const getIndex = () => {
    if (Array.isArray(ruleParameters) && ruleParameters.length === 0) return -1
    if (ruleParameters) return ruleParameters?.map((e) => e.filterTemplate).indexOf(filterTemplate)
    return -1
  }

  useEffect(() => {
    const aux = ruleParameters?.find((e) => e.filterTemplate === filterTemplate)

    if (aux && JSON.stringify(aux[propertie]) !== JSON.stringify(value)) {
      setValue(aux[propertie] || false)
    }

    if (!aux) {
      setValue(false)
    }
  }, [ruleParameters, propertie, filterTemplate])

  const checkHandler = (newValue) => {
    updateRuleParameters(newValue)
  }

  // const updateRuleParameters = (newValue) => {
  //   const updatedParameters = { ...ruleParameters }

  //   if (newValue) {
  //     updatedParameters[propertie] = newValue
  //   } else {
  //     delete updatedParameters[propertie]
  //   }

  //   setRuleParameters(updatedParameters)
  // }

  const updateRuleParameters = (newValue) => {
    setValue(newValue)

    const index = getIndex()
    const updatedParameters = [...ruleParameters]

    if (newValue) {
      if (index >= 0) {
        updatedParameters[index] = {
          ...updatedParameters[index],
          [propertie]: newValue,
        }
      } else {
        updatedParameters.push({
          [propertie]: newValue,
          filterTemplate,
        })
      }
    } else {
      // Si el objeto está vacío, remover el filtro
      if (index !== -1) {
        updatedParameters.splice(index, 1)
      }
    }

    setRuleParameters(updatedParameters)
  }

  return (
    <Box className="checkbox-input-container">
      <Box className="checkbox-input-row">
        <Box className="checkbox-label">
          <Typography variant="title3">{t(`rules:${toCamelCase(label)}`)}</Typography>
          <Checkbox disabled={!isEditing} checked={value} onChange={() => checkHandler(!value)} />
        </Box>

        {text && <Typography variant="subtitle4">{t(`rules:${toCamelCase(text)}`)}</Typography>}
      </Box>
    </Box>
  )
}

export default CheckboxItem
